import React from 'react';
import { Glyphicon } from 'react-bootstrap';

const LoadingScreenComponent = (props) => {
  const styleDisplay = !props.loading ? 'none' : '';
  const styleMainDiv = props.loading ? { width: '100vw', height: '100vh', overflow: 'hidden' } : {};
  return (<div style={styleMainDiv}>
    <div
      style={{ top: '50vh',
        left: '50vw',
        position: 'absolute',
        zIndex: '10001',
        display: styleDisplay }}
      id="loading-cog"
    >
      <Glyphicon glyph="cog" className="glyph-spin large" style={{ fontSize: '200%' }} />
    </div>
    <div
      style={{ width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        background: 'lightgray',
        opacity: '0.9',
        position: 'absolute',
        zIndex: '10000',
        display: styleDisplay }}
    />
    {props.children}
  </div>);
};
LoadingScreenComponent.propTypes = {
  children: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  loading: React.PropTypes.bool,
  dataLoaded: React.PropTypes.bool,
};

export default LoadingScreenComponent;
